const vegetables ={
    productData:[
        {
            id: 1,
            img: require('../Components/Images/Vegetables/Ashgourd.webp'),
            title: 'Ashgourd',
            desc: '',
            price: '87.00',
        },
        {
            id: 2,
            img: require('../Components/Images/Vegetables/Beans1.webp'),
            title: 'Bingo Blue',
            desc: '',
            price: '45.00',
        },
        {
            id: 3,
            img: require('../Components/Images/Vegetables/Beans.png'),
            title: 'Bingo Green',
            desc: '',
            price: '47.00',
        },
        {
            id: 4,
            img: require('../Components/Images/Vegetables/Beetroot.webp'),
            title: 'Bingo Green',
            desc: '',
            price: '89.00',
        },
        {
            id: 5,
            img: require('../Components/Images/Vegetables/Bittergourd.png'),
            title: 'Bittergourd',
            desc: '',
            price: '78.00',
        },
        {
            id: 6,
            img: require('../Components/Images/Vegetables/Bottlegourd.webp'),
            title: 'Bottlegourd',
            desc: '',
            price: '78.00',
        },
        {
            id: 7,
            img: require('../Components/Images/Vegetables/Brinjal.webp'),
            title: 'Brinjal',
            desc: '',
            price: '78.00',
        },
        {
            id: 8,
            img: require('../Components/Images/Vegetables/Brinjal2.png'),
            title: 'Brinjal Hybrid',
            desc: '',
            price: '78.00',
        },
        {
            id: 9,
            img: require('../Components/Images/Vegetables/Broccoli.png'),
            title: 'Broccoli',
            desc: '',
            price: '78.00',
        },
        {
            id: 10,
            img: require('../Components/Images/Vegetables/Cabbage.png'),
            title: 'Cabbage',
            desc: '',
            price: '78.00',
        },
        {
            id: 11,
            img: require('../Components/Images/Vegetables/Cabbage1.webp'),
            title: 'Cabbage Hybrid',
            desc: '',
            price: '78.00',
        },
        {
            id: 12,
            img: require('../Components/Images/Vegetables/Carrot.webp'),
            title: 'Carrot',
            desc: '',
            price: '78.00',
        },
        {
            id: 13,
            img: require('../Components/Images/Vegetables/Cauliflower.webp'),
            title: 'Cauliflower',
            desc: '',
            price: '78.00',
        },
        {
            id: 14,
            img: require('../Components/Images/Vegetables/Celery.webp'),
            title: 'Celery',
            desc: '',
            price: '78.00',
        },
        {
            id: 15,
            img: require('../Components/Images/Vegetables/Chowchow.png'),
            title: 'Chowchow',
            desc: '',
            price: '78.00',
        },
        {
            id: 16,
            img: require('../Components/Images/Vegetables/Clusterbeans.webp'),
            title: 'Clusterbeans',
            desc: '',
            price: '78.00',
        },
        {
            id: 17,
            img: require('../Components/Images/Vegetables/Corn.png'),
            title: 'Corn',
            desc: '',
            price: '78.00',
        },
        {
            id: 18,
            img: require('../Components/Images/Vegetables/Cucumber.png'),
            title: 'Cucumber',
            desc: '',
            price: '78.00',
        },
        {
            id: 19,
            img: require('../Components/Images/Vegetables/Drumstick.png'),
            title: 'Drumstick',
            desc: '',
            price: '78.00',
        },
        {
            id: 20,
            img: require('../Components/Images/Vegetables/Elephantyam.webp'),
            title: 'Elephantyam',
            desc: '',
            price: '78.00',
        },
        {
            id: 21,
            img: require('../Components/Images/Vegetables/Garlic.png'),
            title: 'Garlic',
            desc: '',
            price: '78.00',
        },
        {
            id: 22,
            img: require('../Components/Images/Vegetables/Ginger.webp'),
            title: 'Ginger',
            desc: '',
            price: '78.00',
        },
        {
            id: 23,
            img: require('../Components/Images/Vegetables/Greenpapaya.png'),
            title: 'Greenpapaya',
            desc: '',
            price: '78.00',
        },
        {
            id: 24,
            img: require('../Components/Images/Vegetables/Greenpeas.png'),
            title: 'Greenpeas',
            desc: '',
            price: '78.00',
        },
        {
            id: 25,
            img: require('../Components/Images/Vegetables/Ladysfinger.png'),
            title: 'Ladysfinger',
            desc: '',
            price: '78.00',
        },
        {
            id: 26,
            img: require('../Components/Images/Vegetables/Mushroom.png'),
            title: 'Mushroom',
            desc: '',
            price: '78.00',
        },
        {
            id: 27,
            img: require('../Components/Images/Vegetables/Onion.webp'),
            title: 'Onion',
            desc: '',
            price: '78.00',
        },
        {
            id: 28,
            img: require('../Components/Images/Vegetables/Papaya.png'),
            title: 'Papaya',
            desc: '',
            price: '78.00',
        },
        {
            id: 29,
            img: require('../Components/Images/Vegetables/Potato.webp'),
            title: 'Potato',
            desc: '',
            price: '78.00',
        },
        {
            id: 30,
            img: require('../Components/Images/Vegetables/Pumpkin.webp'),
            title: 'Pumpkin',
            desc: '',
            price: '78.00',
        },
        {
            id: 31,
            img: require('../Components/Images/Vegetables/Radish.webp'),
            title: 'Radish',
            desc: '',
            price: '78.00',
        },
        {
            id: 32,
            img: require('../Components/Images/Vegetables/Radish2.png'),
            title: 'Radish2',
            desc: '',
            price: '78.00',
        },
        {
            id: 33,
            img: require('../Components/Images/Vegetables/Ridgegourd.png'),
            title: 'Ridgegourd',
            desc: '',
            price: '78.00',
        },
        {
            id: 34,
            img: require('../Components/Images/Vegetables/SmallOnion.png'),
            title: 'SmallOnion',
            desc: '',
            price: '78.00',
        },
        {
            id: 35,
            img: require('../Components/Images/Vegetables/Snakegourd.webp'),
            title: 'Snakegourd',
            desc: '',
            price: '78.00',
        },
        {
            id: 36,
            img: require('../Components/Images/Vegetables/Spinach.webp'),
            title: 'Spinach',
            desc: '',
            price: '78.00',
        },
        {
            id: 37,
            img: require('../Components/Images/Vegetables/Springonion.webp'),
            title: 'Springonion',
            desc: '',
            price: '78.00',
        },
        {
            id: 38,
            img: require('../Components/Images/Vegetables/SweetPotato.png'),
            title: 'SweetPotato',
            desc: '',
            price: '78.00',
        },
        {
            id: 39,
            img: require('../Components/Images/Vegetables/SweetPotato1.webp'),
            title: 'SweetPotato Raw',
            desc: '',
            price: '78.00',
        },
        {
            id: 40,
            img: require('../Components/Images/Vegetables/Turnip.png'),
            title: 'Turnip',
            desc: '',
            price: '78.00',
        },
        {
            id: 41,
            img: require('../Components/Images/Vegetables/Whitepumpkin.webp'),
            title: 'Whitepumpkin',
            desc: '',
            price: '78.00',
        }


    ],
};

export default vegetables; 